import {createRouter, createWebHistory} from 'vue-router';
import * as PageNames from '@/enmus/PageNames';

const Home = () => import('@/views/Home.vue');
import UserManage, {UserInfo} from './user';
import Strategy, {JsStrategyHistory} from './strategy';
import Intelligence from './intelligence';
import DataReport from './dataReport';
import Intervene from './intervene';
import Introduce from './introduce';
import Login from './login';
import Dock from './dock';
import Docs from './docs';
import Root from '@/views/Root.vue';
import BusinessAnalyse from './businessAnalyse';
// import Situation from './situation';

const NotFoundPage = () => import('@/views/404.vue');

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            // 会匹配所有路径
            path: '/*',
            component: NotFoundPage,
            name: PageNames.NOT_FOUND_PAGE,
            meta: {
                name: PageNames.NOT_FOUND_PAGE,
                title: '未找到页面'
            }
        },
        {
            // 老版本兼容
            path: '/dataMonitor',
            redirect: {name: PageNames.JS_DATA_MONITOR}
        },
        {
            path: '/',
            component: Home,
            redirect: {name: PageNames.JS_DATA_MONITOR},
            children: [
                Dock,
                DataReport,
                UserManage,
                Intervene,
                Intelligence,
                Strategy,
                Docs,
                UserInfo,
                BusinessAnalyse
            ]
        },
        {
            path: '/',
            component: Root,
            children: [
                Login,
                JsStrategyHistory,
                // Situation,
                Introduce
            ]
        }
    ]
});

export function getRouter() {
    return router;
}

export default router;